<template>
    <div class="pl-10">
        <h2 class="text-2xl">Completion</h2>
        <p>Below are all available Compulsory And Elective courses (<em>including status on if they have been taken or not</em>). </p>
        <div class="flex flex-wrap">
            <div class="lg:w-1/2 md:w-1/2 w-full my-4">
                <h3 class=""><strong>Compulsory Courses</strong></h3>
                <em>Compulsory Courses need to be completed first</em>
                <div class="my-2" v-for="course in compulsoryCourses" :key="course.id">
                    <div class="flex flex-wrap items-center justify-between bg-white py-4 px-3 rounded" style="width:85%">
                        <div class="flex items-center">
                            <div class="mr-3">
                                <input type="checkbox" :checked="course.progress >= 100" disabled>
                            </div>
                            <div>
                                {{ course.title }}
                            </div>
                        </div>
                        <br/>
                        <div> <!--v-if="course.progress < 100"-->
                            <lms-button @click="
                            $router.push({
                                name: 'learner-home',
                                params: { course_id: course.id },
                            })
                                " class="my-1 ml-5">{{ courseButtonStatus(course) }}
                            </lms-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:w-1/2 md:w-1/2 w-full my-4">
                <h3 v-if="coursesCountElectives > 0"><strong>Elective Courses</strong></h3>
                <em v-if="coursesCountElectives > 0">Elective Courses are ONLY available after completing all {{ count_compulsory }} Compulsory Courses</em>
                <div v-if="completedCompulsoryCourses">
                    <div class="my-2"  v-for="course in electiveCourses" :key="course.id">
                        <div class="flex flex-wrap items-center justify-between bg-white py-4 px-3" style="width:95%">
                            <div class="flex items-center">
                                <div class="mr-3">
                                    <input type="checkbox" :checked="course.progress >= 100" disabled>
                                </div>
                                <div>
                                    {{ course.title }}
                                </div>
                            </div>
                            <br/>

			   <div v-if="isPostProgramSurvey(course.id) && (!completedCompulsory || !completedElectives)"> <!--course.progress < 100-->
                                <p><em>Please complete all <b>10 Compulsory</b> and <b>atleast {{ count_elective }} Elective</b> Courses</em></p>
                            </div>
                            <div v-else-if="isPostProgramSurvey(course.id) && (completedCompulsory && completedElectives)"> <!--course.progress < 100-->
                                <lms-button @click="
                                $router.push({
                                    name: 'learner-home',
                                    params: { course_id: course.id },
                                })
                                    " class="my-1 ml-5">{{ courseButtonStatus(course) }}
                                </lms-button>
                            </div>

                          <div v-else-if="!isPostProgramSurvey(course.id)"> <!--course.progress < 100-->
                                <lms-button @click="
                                $router.push({
                                    name: 'learner-home',
                                    params: { course_id: course.id },
                                })
                                    " class="my-1 ml-5">{{ courseButtonStatus(course) }}
                                </lms-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-4 ">
            <div>
                <h2 class="text-2xl">Completion survey</h2>
                <p>After completing all ({{ count_compulsory + count_elective }}) courses, you are required to take a "Post-Program Survey" as part of the program requirements.</p>
                <div v-if="hasCompletedAllCourses">
                    <!-- <div v-for="(course, i) in courses" :key="i">
                        <my-course-card  v-if="course.title === 'Post- Program Survey'" :course="course.course" class="bg-white flex"
                        />
                    </div> -->
                    <lms-button @click="
                    $router.push({
                        name: 'learner-home',
                        params: { course_id: postProgramSurveyCourseId},
                    })
                        " class="my-1 ml-5">Take Post Program Survey
                    </lms-button>
                </div>
            </div>
        </div>

        <div class="my-4 " v-if="canShowGrowthPlan">
            <h2 class="text-2xl">Growth Plans</h2>
            <p>After completing your Post-Program Survey, you are required to complete all <b>Growth Plans</b> (as shown below) to meet your program completion requirements</p>
              <lms-button  @click="
              $router.push({
                name: 'learner-growthplan-home'
              })
            " class="my-1 ml-5">
             Take Your Growth Plans Now
             </lms-button>
        <div class="block sm:flex sm:justify-even sm:flex-wrap">
            <div class="w-full flex flex-wrap" v-for="(question, index) in form.response" :key="index">
                <div class="flex w-full flex-wrap justify-between">
                    <p v-html="question.question" class="py-2 uppercase main-tenant-color"></p>                 
                </div>
                <main class="mx-5 my-5">
                    <textarea  class="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none" rows="10" disabled v-if="question !== null && question.has_image !== 1" v-model="question.answer"  >
                    </textarea>
                            <div v-if="question !== null && typeof question.template_answer !== 'undefined' ">
                            <button disabled v-if="typeof question.template_answer !== 'undefined'  && question.template_answer !== null &&  question.template_answer !== '' " 
                            class="h-8 px-4 text-sm text-pink-100 transition-colors duration-150 bg-indigo-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800" type="submit"  >
                           <a :href=" question.template_answer"  download>You Can View Your Uploaded Answer By Clicking  Here</a>
                        </button>
                            </div>
                        <button @click=" $router.push({name: 'learner-growthplan-single',params: {id: question.growth_plan_id,course_id: question.course_id}, query: {view : 'review'}})"  v-if="typeof question.reg_question_id  === 'undefined' || question.reg_question_id  === null " 
                            class="h-8 mt-5 mb-5  px-4 text-sm text-pink-100 transition-colors duration-150 bg-red-700 rounded-lg cursor-pointer focus:shadow-outline hover:bg-indigo-800" type="submit"  >
                           <a> Click Here to Review this</a>
                        </button>
                        <h3 v-else style="font-size:20px;"  class="text-green-300 mt-10">Growth Plan Question Succefully Taken</h3>
                      
                    </main>   
            </div>
        
    </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapMutations,mapGetters } from "vuex";
export default {
    data(){
        return {
          courses:{},
          growthplans: [],
          canShowGrowthPlan:false,
          planResponses: [],
          submitResponses: [],
          finalSubmitResponses: [],
          reviewSubmitResponses: [],
          form:{
            
          },
          completedCompulsoryCourses: false,
          completedElectivesCourses: false,
          completedPreProgramSurvey: false,
          coursePreProgramSurvey: {},
          default_program_resource: {},
          default_program_settings_resource: {},
          count_compulsory: 12,
          count_elective: 0,
          LMSUserItem: JSON.parse(localStorage.getItem("lms-user")),
          coursesCountCompulsory: 0,
          coursesCountElectives: 0,
          hasCompletedAllCourses: false,
	  postProgramSurveyCourseId: '91a06af8-85fe-4e23-a646-5373e7a73a48', // Default Post Program Survey
        }
    },
    components: {
        MyCourseCard: () => import("@/components/learner/my-course-card"),
          LmsButton: () => import("@/components/general/button"),
    },
    computed:{
        ...mapGetters(["getSubscribedCourses"]),
        compulsoryCourses(){
            if(this.courses.length > 0){
                return this.courses.filter((item) => {
                    if(item.course_level === 'compulsory'){
                        return item;
                    }
                })
            }
        },
        electiveCourses(){
            if(this.courses.length > 0){
                return this.courses.filter((item) => {
                    if(item.course_level === 'elective'){
                        return item;
                    }
                })
            }
        }
    },
    methods:{
        ...mapActions(["learnerSubscribedCourses","learnerFetchGrowthPlanCourses"]),
        ...mapMutations(["updateLoader"]),
        courseButtonStatus(courseData) {
          let elementType = "Course";
	  if ([
                'bc1b9df6-f3d9-4ed1-ba4e-9fdd33e446c2',
                '91a06af8-85fe-4e23-a646-5373e7a73a48', 
            ].includes(courseData.id)) {
                elementType = 'Survey';
          }

          if (courseData.progress >= 100) {
              return 'COMPLETED ' + elementType;
          } else if (courseData.progress > 0 && courseData.progress < 100) {
              return 'RESUME ' + elementType;
          } else {
              return 'START ' + elementType;
          }
        },

       isPostProgramSurvey(courseID) {
            if (['91a06af8-85fe-4e23-a646-5373e7a73a48', 'fb480c53-9f31-4a41-beb7-30fe30606f87'].includes(courseID)) {
                return true;
            } else {
                return false;
            }
        },
	updatePostProgramSurveyCourseId() {
            if (this.LMSUserItem.default_program === '5a1113d6-3924-41e6-b815-daad0bc005e1') {
                this.postProgramSurveyCourseId = 'fb480c53-9f31-4a41-beb7-30fe30606f87';
            } else {
                this.postProgramSurveyCourseId = '91a06af8-85fe-4e23-a646-5373e7a73a48'; // Reset to default if not the specific program
            }
        },
        hasPrePostSurveys() {
            if (this.LMSUserItem.default_program == "4f1b9237-da53-4812-be86-841bee6a8971" ||
		this.LMSUserItem.default_program == "5a1113d6-3924-41e6-b815-daad0bc005e1" ) {
                return true;
            } else {
                return false;
            }
        },
        hasGrowthPlans() {
            if (this.LMSUserItem.default_program == "4f1b9237-da53-4812-be86-841bee6a8971" ||
		this.LMSUserItem.default_program == "5a1113d6-3924-41e6-b815-daad0bc005e1") {
                return true;
            } else {
                return false;
            }
        },
        async subscribeLearner() {
            this.updateLoader(true)
            try {
                const res = await Object.values(this.getSubscribedCourses);
                this.courses = res;
                //console.log(res)
                let completedElectives = [];
                let notCompletedElectives = [];
                let completedCompulsory = [];
                let notCompletedCompulsory = [];
                // console.log(res)
                this.courses.forEach((item) => {
                  //console.log(item);
                    if(item.course_level === 'elective') {
                      if (!item.title.toLowerCase().includes("survey")) {
                        this.coursesCountElectives += 1;
                      }
                      
                      if (item.progress >= 100 && !item.title.toLowerCase().includes("survey")) {
                        completedElectives.push(item);
                      }
                        
                    }
                    if ((item.id == 'bc1b9df6-f3d9-4ed1-ba4e-9fdd33e446c2' || item.id == 'fb480c53-9f31-4a41-beb7-30fe30606f87') && item.progress >= 100) {
                      this.completedPreProgramSurvey = true;
                      this.coursePreProgramSurvey = item;
                    }

                    if(item.course_level === 'compulsory') {
                      if (!item.title.toLowerCase().includes("survey")) {
                        this.coursesCountCompulsory += 1;
                      }
                      if (item.progress >= 100 && !item.title.toLowerCase().includes("survey")) {
                        completedCompulsory.push(item);
                      }   
                    }
                })
               
                //this.courses.forEach((item) => {
                //    if(item.course_level === 'compulsory') {
                //      this.coursesCountCompulsory += 1;
                //      if (item.progress >= 100) {
                //        completedCompulsory.push(item);
                //      }   
                //    }
                //})

                if (completedCompulsory.length >= this.count_compulsory) {
                  this.completedCompulsoryCourses = true;
                }

                if (completedElectives.length >= this.count_elective) {
                  this.completedElectivesCourses = true;
                }
        
                let data = {
                    completedElectives: completedElectives.length,
                    completedCompulsory: completedCompulsory.length,
                };
              let message = '';
              //let compare_elective = this.hasPrePostSurveys() ? this.count_elective + 1 : this.count_elective;
              let compare_elective = this.count_elective;

              //update what count_compulsory and count_elective is here for non TNY
              if (this.LMSUserItem.default_program != "4f1b9237-da53-4812-be86-841bee6a8971") {
                this.count_compulsory = this.coursesCountCompulsory;
                this.count_elective = this.coursesCountElectives;
              }


              if (data.completedCompulsory < this.count_compulsory) {
                message += 'You have  <b>' + (this.count_compulsory - parseInt(data.completedCompulsory)) + '</b>  courses left to complete your compulsory courses <br> ';
              }
	     
	      if (data.completedCompulsory >= this.count_compulsory) {this.hasCompletedAllCourses = true;
   		 message += 'You have completed all your required courses! Ensure you fill and submit your Growth Plans!';
	      }

            //  if (this.count_elective > 0 && data.completedElectives < compare_elective) {
            //    message += 'You have  <b>' + (compare_elective - parseInt(data.completedElectives)) + '</b>  courses left to complete your elective courses <br> ';
            //  }
                  
            //  if ((this.count_elective == 0 && data.completedCompulsory >= this.count_compulsory) || (this.count_elective > 0 && (data.completedCompulsory >= this.count_compulsory && data.completedElectives >= compare_elective) )) {
            //    this.hasCompletedAllCourses = true;
            //    message += 'You have completed all your required courses! Ensure you fill and submit your Growth Plans!';
            //  }


              //switch (true) {
              //  case (data.completedCompulsory < this.count_compulsory && data.completedElectives < compare_elective):
              //    message = 'You have  <b>' + (this.count_compulsory - parseInt(data.completedCompulsory)) +'</b>  courses left to complete your compulsory courses <br> ' +
              //        'You have  <b>' + (compare_elective - parseInt(data.completedElectives)) +'</b> ' +
              //        'courses left to complete your elective courses <br> '
              //  break
              //  case (data.completedCompulsory < this.count_compulsory && data.completedElectives > compare_elective):
              //    message = 'You have  <b>' + (this.count_compulsory - parseInt(data.completedCompulsory)) +'</b>  courses left to complete your compulsory courses <br> '
              //  break
              //  case (data.completedCompulsory >= this.count_compulsory && data.completedElectives < compare_elective):
              //    message =   'You have  <b>' + (this.count_elective - parseInt(data.completedElectives)) +'</b> ' +
              //        'courses left to complete your elective courses <br> '
              //    break
              //  case (data.completedCompulsory >= this.count_compulsory && data.completedElectives >= compare_elective):
              //    message = 'You have completed all your required courses! Ensure you fill and submit your Growth Plans!'
              //  break
              //  default:
              //    break
              //}

              //if (data.completedCompulsory >= this.count_compulsory && data.completedElectives >= compare_elective){
		if (data.completedCompulsory >= this.count_compulsory){

                 this.$swal(
                    'Good job!',
                    message,
                    'success'
                )
              } else {

                this.$swal({
                  title: '<strong>Completion Status</strong>',
                  icon: 'warning',
                  html: message,
                  showCloseButton: true,
                  showCancelButton: false,
                  focusConfirm: false,
                  confirmButtonText:
                      'Proceed',
                  confirmButtonAriaLabel: 'Proceed',
                })
              }


                //console.log(data);


                this.updateLoader(false)
            }catch (e) {
                this.updateLoader(false)
            }
        },
        async fetchGrowthPlans() {
            try {
                this.updateLoader(true)
                let res = await this.learnerFetchGrowthPlanCourses();
                let growthplancourses = [];
                for (let plans of res.data.data.growth_plans) {
                    if (plans.title !== null || typeof plans !== "undefined") {
                        if (plans.completed === "completed") {
                            this.hasSubmitted = true;
                        }
                        this.growthplans.push(plans);
                    }
                }
                // GET {{baseUrl}}/tenant/growth_plan/learner/course-list/show


                let complete_response = false;
                let isComplete = true;
                for (let plan of this.growthplans) {
                    if (plan.completed === "Incomplete" && plan.title !== null) {
                        continue;
                    }
                    let response = [];
                    for (let res of plan.responses) {
                        res.course_id = plan.course_id;
                        response.push(res);
                    }
                    if (response !== null && response.length > 0) {
                        try {
                            this.submitResponses.push(response);
                            complete_response = true;
                        } catch (e) {
                            // this.$Bus.$emit("notify", {
                            //     type: "error",
                            //     message: 'An Error Occured while trying to compile some of the growthplan  responses'
                            // });
                        } finally {
                        }
                    }
                }
                if (isComplete) {
                    dance: for (let responses of this.submitResponses) {
                    // console.log(responses)
                    for (let response of responses) {
                        if (
                        typeof response.answer !== "undefined" &&
                        response.answer !== null &&
                        response.answer !== ""
                        ) {
                        this.reviewSubmitResponses.push(response);
                        if (
                            response.reg_question_id !== null &&
                            typeof response.reg_question_id !== "undefined"
                        ) {
                            this.finalSubmitResponses.push({
                            question: response.title,
                            answer: response.answer,
                            question_id: response.reg_question_id
                            });
                        }
                        } else {
                        continue;
                        }
                    }
                    }
                }

                if (isComplete) {
                    let data = [this.finalSubmitResponses, this.reviewSubmitResponses];
                    this.form.response = this.reviewSubmitResponses;
                    this.canShowGrowthPlan = true;
                }
                this.loading = false;
                this.updateLoader(false);
            
            } catch(err) {
                console.log(err)
            }
        }
    },
    async mounted() {
	this.updatePostProgramSurveyCourseId();

        //console.log('Debug Completion getSubscribedCourses');
        //console.log(this.getSubscribedCourses);
        await this.subscribeLearner();
        if (this.hasGrowthPlans()) {
            await this.fetchGrowthPlans();
        }

        //this.default_program_resource = this.LMSUserItem.default_program_resource;
        //this.default_program_settings_resource = this.LMSUserItem.default_program_settings_resource;
        //this.count_compulsory = this.default_program_settings_resource.compulsory_count;
        //this.count_elective = this.default_program_settings_resource.elective_count;

        //console.log(this.LMSUserItem);
        //console.log(this.default_program_settings_resource);

    },
    async created(){
        await this.updateLoader(true)
        await this.learnerSubscribedCourses()
        await this.updateLoader(false)
    }
}
</script>
